import { render, staticRenderFns } from "./PdvList.vue?vue&type=template&id=3e5b645a&scoped=true&"
import script from "./PdvList.vue?vue&type=script&lang=js&"
export * from "./PdvList.vue?vue&type=script&lang=js&"
import style0 from "./PdvList.vue?vue&type=style&index=0&id=3e5b645a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5b645a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
